<section class="page">
  <div class="page-header">
    <h1>Termin erfolgreich gebucht</h1>
    <p>Wir haben Ihren Termin reserviert. Eine Bestätigung erhalten Sie per SMS.</p>
  </div>

  <mat-card class="success-card">
    <div class="success-icon">
      <mat-icon>check_circle</mat-icon>
    </div>
    <div class="success-content">
      <h2>Vielen Dank!</h2>
      <p>Ihr Termin wurde erfolgreich eingetragen.</p>
      <p class="confirmation-id" *ngIf="flowState.snapshot.bookingConfirmation as booking">
        Bestätigungsnummer: {{ booking.confirmationId }}
      </p>
      <p class="patient-name" *ngIf="flowState.snapshot.patientDetails as patient">
        Patient: {{ patient.firstName }} {{ patient.lastName }}
      </p>
    </div>
  </mat-card>

  <div class="success-grid">
    <app-appointment-summary-card
      [preselection]="flowState.snapshot.preselection"
      [day]="flowState.snapshot.selectedDay"
      [slot]="flowState.snapshot.selectedSlot"
    ></app-appointment-summary-card>

    <mat-card class="next-steps-card">
      <h3>Was passiert als Nächstes?</h3>
      <p>Je nach Praxis können weitere Formulare folgen. Wir bereiten die Übergabe an die Patienten-App vor.</p>
      <button mat-flat-button color="primary" (click)="continueToPatientForms()">Weiter zu den Formularen</button>
      <div class="patient-entry-message" *ngIf="patientEntryMessage">{{ patientEntryMessage }}</div>
      <button mat-stroked-button color="primary" class="secondary-action" (click)="startNewBooking()">
        Neue Buchung starten
      </button>
    </mat-card>
  </div>
</section>
